import { CLOUDINARY_CLOUD_NAME, CLOUDINARY_UPLOAD_PRESET } from '../config/cloudinary.config';
import { isMySqlEnabled, apiClient } from '../services/apiClient';

const compressAndCleanImage = (file: File): Promise<string> => {

  return new Promise((resolve) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target?.result as string;
    };

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return resolve(img.src);

      const MAX_SIZE = 1200;
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > MAX_SIZE) {
          height = Math.round((height * MAX_SIZE) / width);
          width = MAX_SIZE;
        }
      } else {
        if (height > MAX_SIZE) {
          width = Math.round((width * MAX_SIZE) / height);
          height = MAX_SIZE;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      try {
        const webpData = canvas.toDataURL('image/webp', 0.82);
        resolve(webpData);
      } catch (e) {
        const jpegData = canvas.toDataURL('image/jpeg', 0.82);
        resolve(jpegData);
      }
    };

    img.onerror = () => {
      reader.readAsDataURL(file);
    };

    reader.readAsDataURL(file);
  });
};

export const uploadToCloudinary = async (file: File, folderPath?: string): Promise<string> => {
  const cleanedDataUrl = await compressAndCleanImage(file);

  if (isMySqlEnabled()) {
    try {
      const formData = new FormData();
      formData.append('image', file);
      if (folderPath) formData.append('type', folderPath);
      const res: any = await apiClient.post('/upload', formData);

      if (res && (res.relativePath || res.url)) {
        return res.relativePath || res.url;
      }
    } catch (err) {
      console.warn('Carga via backend falló, fallback a base64 limpio:', err);
    }
    return cleanedDataUrl;
  }

  if (!CLOUDINARY_CLOUD_NAME) {

    return cleanedDataUrl;
  }

  try {
    console.log("Iniciando carga a Cloudinary:", file.name, "en carpeta:", folderPath);
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    
    if (folderPath) {
      formData.append('folder', folderPath);
    }
    
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
      {
        method: 'POST',
        body: formData,
      }
    );
    
    if (!response.ok) {
      const errorText = await response.text();
      console.warn("Cloudinary error, fallback to base64:", errorText);
      return cleanedDataUrl;
    }
    
    const data = await response.json();
    console.log("Respuesta exitosa de Cloudinary:", data.secure_url);
    return data.secure_url;
  } catch (error) {
    console.warn('Error in Cloudinary upload, fallback to base64:', error);
    return cleanedDataUrl;
  }
};



export default {
  uploadToCloudinary
};